// extracted by mini-css-extract-plugin
export default {"shareIconContainer":"LpCopyReportUrl_shareIconContainer__igXFE","responseCountIcon":"LpCopyReportUrl_responseCountIcon__+b2oh","copyLinkText":"LpCopyReportUrl_copyLinkText__pPRJO"};